// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"624":"public","806":"user","884":"admin"}[chunkId] + "." + {"624":"2571f4e5","806":"932f19a4","884":"3af7f96e"}[chunkId] + ".css";
};